import React from "react";
import { connect } from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import extendedTablesStyle from "../../assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.jsx";
import ReactTable from "react-table";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { Select, MenuItem, InputLabel } from "@material-ui/core";
// Icons
//core components
import TextField from "@material-ui/core/TextField";
// import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import Card from "../../components/Card/Card.jsx";
// import CardBody from "components/Card/CardBody.jsx";
// import CardIcon from "components/Card/CardIcon.jsx";
// import CardHeader from "components/Card/CardHeader.jsx";
// import Avatar from "@material-ui/core/Avatar";
// import IconButton from "@material-ui/core/IconButton";
// import Icon from "@material-ui/core/Icon";
// import Tooltip from "@material-ui/core/Tooltip";
// import Switch from "@material-ui/core/Switch";
// import green from "@material-ui/core/colors/green";
// import DeleteModel from "../../components/Common/FevoModels/DeleteModel";
import { getCustomerData } from "../../actions/customerActions";
import toastr from "toastr";
import axios from "axios";
import { domain } from "../../utils/util";
import { Button, CardContent } from "@material-ui/core";
import { Form } from "react-bootstrap";

class ManageCustomers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      first_name:"",
      middle_name:"",
      last_name:"",
      dob:"",
      gender:"",
      email:"",
      bermudian:"",
      isEdit: false,
      addCategory: false,
      flightData: null,
      selectedDate: null,
    
    };
  }

  componentDidMount = () => {
   
  };

  submitForm = (e) => {
    e.preventDefault();
    let body = {
     "first_name":this.state.first_name,
     "email":this.state.email,
     "middle_name":this.state.middle_name,
     "last_name":this.state.last_name,
     "gender":this.state.gender,
     "dob":this.state.dob,
     "bermudian":this.state.bermudian,

    };
    
    let data = JSON.parse(localStorage.getItem("BerPay_Admin"));
    let config = {};
    if (data) {
      config = {
        headers: { Authorization: `Bearer ${data.token}` },
      };
    }
      axios
        .post(`${domain}/user/create/customer/users`, body, config)
        .then((res) => {
          if (res.data.statusCode === 200 || res.data.statusCode === 201) {
            toastr.success("Customer Added Successfully!")
            this.props.history.goBack();
          }
        })
        .catch((error) => { });
    
  };

  handleChange = (event) => {
    this.setState({ ...this.state, [event.target.name]: event.target.value });
    this.setState({isEdit:true})
  };

  render() {
    const { classes } = this.props;
    const { first_name,last_name,middle_name,dob,gender,bermudian,email, isEdit, addCategory, filterDate, flightData, flightName, flightNo, selectedDate } = this.state;
    return (
      <div>
        <Card>
          <CardContent>
            <Form onSubmit={this.submitForm}>
              <GridItem xs={12}>
                <TextField
                  autoFocus
                  margin="dense"
                  name="first_name"
                  id="first_name"
                  label="First Name"
                  type="text"
                  //disabled={!isEdit && !addCategory}
                  onChange={this.handleChange}
                  fullWidth
                  value={first_name}
                  style={{ marginBottom: "20px" }}
                  required
                />
              </GridItem>
              <GridItem xs={12}>
                <TextField
                  autoFocus
                  margin="dense"
                  name="email"
                  id="email"
                  label="Email"
                  type="email"
                  //disabled={!isEdit && !addCategory}
                  onChange={this.handleChange}
                  fullWidth
                  value={flightNo}
                  style={{ marginBottom: "20px" }}
                  required
                />
              </GridItem>
              <GridItem xs={12}>
                <TextField
                  autoFocus
                  margin="dense"
                  name="middle_name"
                  id="middle_name"
                  label="Middle Name"
                  type="text"
                  //disabled={!isEdit && !addCategory}
                  onChange={this.handleChange}
                  fullWidth
                  value={middle_name}
                  style={{ marginBottom: "20px" }}
                  required
                />
              </GridItem>
              <GridItem xs={12}>
                <TextField
                  autoFocus
                  margin="dense"
                  name="last_name"
                  id="last_name"
                  label="Last Name"
                  type="text"
                  //disabled={!isEdit && !addCategory}
                  onChange={this.handleChange}
                  fullWidth
                  value={last_name}
                  style={{ marginBottom: "20px" }}
                  required
                />
              </GridItem>
              <GridItem xs={12}>
                <TextField
                  autoFocus
                  margin="dense"
                  name="gender"
                  id="gender"
                  label="Gender"
                  type="text"
                  //disabled={!isEdit && !addCategory}
                  onChange={this.handleChange}
                  fullWidth
                  value={gender}
                  style={{ marginBottom: "20px" }}
                  required
                />
                 <GridItem xs={12}>
                <TextField
                  autoFocus
                  margin="dense"
                  name="dob"
                  id="dob"
                  label="dob"
                  type="text"
                  //disabled={!isEdit && !addCategory}
                  onChange={this.handleChange}
                  fullWidth
                  value={dob}
                  style={{ marginBottom: "20px" }}
                  required
                />
              </GridItem>
              <GridItem xs={12}>
                <TextField
                  autoFocus
                  margin="dense"
                  name="bermudian"
                  id="bermudian"
                  label="Resident"
                  type="text"
                  //disabled={!isEdit && !addCategory}
                  onChange={this.handleChange}
                  fullWidth
                  value={bermudian}
                  style={{ marginBottom: "20px" }}
                  required
                />
              </GridItem>
              </GridItem>
              <GridItem xs={12} className="new_Card">
                {/* {(addCategory || isEdit) && ( */}
                  <Button variant="contained" color="primary" type="submit">
                    Submit
                  </Button>
                {/* )} */}
              </GridItem>
            </Form>
          </CardContent>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    // users: state.products.categories
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCustomerData: () => dispatch(getCustomerData()),
    // fetchCategories: ()=> dispatch(fetchCategories()),
    // categoryFormContent: (obj) => {dispatch({ type: PRODUCT_CATEGORY_ACTION.OPEN_CATEGORY_FORM, payload: obj })},
    // editCategory: (obj) => dispatch(editCategory(obj)),
    // deleteCategory: (obj,callback) => dispatch(deleteCategory(obj,callback)),
  };
};

const ManageCustumersComponent = withStyles(extendedTablesStyle)(
  ManageCustomers
);
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ManageCustumersComponent);
